import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "../login";
import ForgotPass from "../forgotPass";
import ResetPass from "../resetPass";
import OtpScreen from "../otpScreen";
import EmailVerification from "../emailVerification";
import AllModals from "../allModals";
// eslint-disable-next-line no-unused-vars
import Page404 from "../404";
import Reject from "../reject";
import Approve from "../approve";
import Error from "../error";
import LoginViaPhoneOtp from "../loginViaPhoneOtp";
import { useDispatch, useSelector } from "react-redux";
import Success from "../success";
import POCLogin from "../pocLogin";
import LoginViaEmailOtp from "../emailOtp";
import AdminSignupOTP from "../Components/Onboarding/adminSignupOTP";
import Dashboard from "../Components/dashboard/index";
import UserPrivateRoute from "../config/PrivateRoutes";
import Signup from "../Pages/signup";

function Index() {
  const router = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const origin = window.location.origin ? window.location.host : "";
    const parts = origin?.split(".");
    if (parts.length > 0) {
      const name = parts[1];
      const parts1 = name?.split(".");
      if (parts1) {
        const username = parts1[0];
        if (username && username === "maxhr") {
          const pathname = window.location.pathname;
          const newUrl = pathname.includes("careers");
          const newScreening = pathname.includes("screening");

          if (newUrl === false || newScreening === false) {
            router("/404");
          }
        }

        // else if (username && username === "meetmax") {
        //   const pathname = window.location.pathname;
        //   const newUrl = pathname.includes("job-post");
        //   if (newUrl) {
        //     window.location.href = process.env.REACT_APP_BACKEND_URI + "/404";
        //   }
        // }
      }
    }
  }, []);

  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  return (
    <Routes>
      {/* <Route path="*" element={<Error404 userType={userType} />} /> */}
      <Route path="/signup" exact element={<Signup />} />
      <Route
        path="/dashboard"
        element={
          <UserPrivateRoute>
            <Dashboard />
          </UserPrivateRoute>
        }
      />
      <Route path="/404" element={<Page404 />} />
      <Route path="/login" element={<Login />} />
      {/* <Route path="/login/email" exact element={<LoginEmail />} /> */}
      <Route path="/login/email/otp" element={<LoginViaEmailOtp />} />

      <Route path="/emailVerify" exact element={<EmailVerification />} />
      <Route path="/" exact element={<Login />} />
      {/* <Route path="/login-via-phone" exact element={<LoginViaPhone />} /> */}
      <Route path="/login-via-phone-otp" element={<LoginViaPhoneOtp />} />
      {/* <Route
        path="/sign-up-via-phone-otp"
        exact
        element={<SignupViaPhoneOtp />}
      /> */}
      <Route path="/sign-up-via-phone-otp" exact element={<AdminSignupOTP />} />
      <Route path="/forgot-password" exact element={<ForgotPass />} />
      <Route path="/reset/:email" exact element={<ResetPass />} />
      <Route path="/otp" exact element={<OtpScreen />} />
      <Route path="/allModals" exact element={<AllModals />} />
      <Route path="/leave/reject" exact element={<Reject />} />
      <Route path="/leave/approve" exact element={<Approve />} />
      <Route path="/leave/error" exact element={<Error />} />
      <Route path="/success" exact element={<Success />} />
      <Route path="/poc" exact element={<POCLogin />} />

      {/* <Route path="/careers" exact element={<CompanyPage />} /> */}
      {/* <Route path="/screening/question" exact element={<ScreeningQuestion />} /> */}

      {/* <Route
        path="/careers/:company/:jobAdPost"
        exact
        element={<JobAdPostDetailsPage />}
      /> */}
      {/* <Route path="/careers/:company" element={<Page404 />} /> */}

      {/* <Route path="/dashboard1" element={<Dashboard />} /> */}
    </Routes>
  );
}

export default Index;
